const PERMISSION_ASSIGNMENT_URL = process.env.API_URL + '/permission-assignment';
const PERMISSIONABLE_AND_ASSIGNABLE_USERS_URL = PERMISSION_ASSIGNMENT_URL + '/users';

const getReadableUsers = (context, user) => {
  return new Promise((resolve, reject) => {
    context.$http.get(PERMISSION_ASSIGNMENT_URL, {params: {userId: user}}).then((users) => {
      resolve(users);
    }, error => {
      reject(error);
    });
  });
};

const updateReadableUsers = (context, user, readableUsers) => {
  return new Promise((resolve, reject) => {
    context.$http.post(PERMISSION_ASSIGNMENT_URL + '/' + String(user), readableUsers).then(() => {
      resolve();
    }, error => {
      reject(error);
    });
  });
};

const getSelectionableAndAssignableUsers = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(PERMISSIONABLE_AND_ASSIGNABLE_USERS_URL).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

export default {
  getReadableUsers,
  updateReadableUsers,
  getSelectionableAndAssignableUsers
};



// WEBPACK FOOTER //
// ./src/api/permissionAssignment/index.js